import axios from "axios";

export const apiInovesystem = axios.create({
	baseURL: "http://localhost:3333/api/inovesystem",
});
